import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import * as Globals from '../../core/globals';
import { LocalService } from '../services/local.service'
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private localService: LocalService){

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    var isLoggedin = (this.localService.getJsonValue('isLoggedin') ? true : false);
    if (isLoggedin) {
      return true;
    } else {
      window.open(Globals.baseUrl + "/login", "_self");
      return false;
    }
  }

}
